import { useIntl } from 'react-intl'

import {
  ConfigKebabContainer,
  ConfigMobileCardContainer,
  ConfigMobileCardLabelWrapper,
  ConfigMobileCardTitle,
  HomeConfigurationWhiteBlock,
} from '../../styles'
import { homeActiveConfigurationMessages } from '../../messages'
import { ConfigFile } from 'components/Icons'
import { KebabMenu } from 'components/KebabMenu'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { commonMessages } from 'app/i18n/messages'
import { DownloadButtonCell } from 'components/Table'
import { HomeActiveConfig } from 'features/home/types'

interface MobileHomeActiveConfigProps {
  original: HomeActiveConfig
  values: Record<string, any>
}

export function MobileHomeActiveConfig(props: MobileHomeActiveConfigProps) {
  const { formatMessage } = useIntl()

  const { values, original } = props

  const { location } = original

  const fileName = `${values.name}.tar.gz`

  return (
    <HomeConfigurationWhiteBlock>
      <ConfigMobileCardContainer>
        <ConfigMobileCardTitle>
          <ConfigFile />
          <span>{values.name}</span>
        </ConfigMobileCardTitle>
        <KebabMenu>
          <ConfigKebabContainer>
            <DownloadButtonCell url={location?.url} fileName={fileName}>
              {formatMessage(commonMessages.download)}
            </DownloadButtonCell>
          </ConfigKebabContainer>
        </KebabMenu>
      </ConfigMobileCardContainer>
      <ConfigMobileCardLabelWrapper>
        <span>{formatMessage(homeActiveConfigurationMessages.updated)}</span>
        <IntlFormattedDate date={values.updated} withTime />
      </ConfigMobileCardLabelWrapper>
    </HomeConfigurationWhiteBlock>
  )
}
